export const formatHeat = (value: number): string => {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)} k`;
  }
  return `${value}`;
};

export const formatCount = (value: number): string => {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  return `${value}`;
};